import { render, staticRenderFns } from "./PgaOfferEvaluationTotalAmountsDiscountedCreate.vue?vue&type=template&id=d6576710&scoped=true&"
import script from "./PgaOfferEvaluationTotalAmountsDiscountedCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationTotalAmountsDiscountedCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PgaOfferEvaluationTotalAmountsDiscountedCreate.vue?vue&type=style&index=0&id=d6576710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6576710",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VFadeTransition,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6576710')) {
      api.createRecord('d6576710', component.options)
    } else {
      api.reload('d6576710', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationTotalAmountsDiscountedCreate.vue?vue&type=template&id=d6576710&scoped=true&", function () {
      api.rerender('d6576710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/PgaOfferEvaluationTotalAmountsDiscountedCreate.vue"
export default component.exports